import { Button, Typography, Box } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import UseTranslation from '../../hooks/UseTranslation'

const SwitchBtn = ({ status, disabled, onClick }) => {
  const { t } = UseTranslation()
  const label = status ? `${t?.Active}` : `${t?.Disabled}`
  const button = status ? `${t?.Disable}` : `${t?.Activate}`
  return (
    <Box sx={styles.root}>
      <FiberManualRecordIcon sx={ { color: status ? 'primary.main' : 'text.hint' }} />
      <Typography sx={{ color: status ? 'primary.main' : 'text.hint' }}>
        {label}
      </Typography>
      {!disabled && (
        <Button
          sx={[styles.btn, {
            color: status ? 'text.hint' : 'primary.main',
          }]}
          onClick={() => {
            onClick(status ? 'Disabled' : 'Active')
          }}>
          {button}
        </Button>
      )}
    </Box>
  );
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    svg: {
      fontSize: { xs: 10, sm: 12 },
      marginRight: '5px',
    },
    p: {
      fontSize: { xs: 12, sm: 16 },
      marginLeft: '5px',
    },
  },
  btn: {
    textTransform: 'capitalize',
    fontSize: { xs: 12, sm: 16 },
    textDecoration: 'underline',
    width: 'max-content',
  },
}

export default SwitchBtn
